import { h } from '@logicflow/core';
import { RectNode, RectNodeModel } from '@logicflow/core';

// 状态节点（圆角矩形）
export class StateNode extends RectNode {
  // 重写getText方法来支持多行文本显示
  getText() {
    const { model } = this.props;
    const { text } = model;

    if (!text || !text.value) {
      return null;
    }

    // 处理多行文本
    const textLines = text.value.split('\n');
    const lineHeight = 14; // 行高，状态节点文字稍小
    const totalHeight = (textLines.length - 1) * lineHeight;

    // 如果只有一行文本，使用父类的默认渲染
    if (textLines.length === 1) {
      return super.getText();
    }

    // 多行文本渲染
    return h(
      'g',
      {
        className: 'lf-node-text-group',
      },
      textLines.map((line, index) =>
        h(
          'text',
          {
            x: text.x,
            y: text.y - totalHeight / 2 + index * lineHeight,
            fill: '#000000',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            style: {
              fontSize: 12,
              userSelect: 'none',
            },
            key: `line-${index}`,
          },
          line
        )
      )
    );
  }

  getShape() {
    const { model } = this.props;
    let { x, y, width, height } = model;

    // 确保所有数值都是有效的，防止NaN导致SVG渲染错误
    x = Number(x) || 0;
    y = Number(y) || 0;
    width = Number(width) || 70;
    height = Number(height) || 30;

    // 验证数值的有效性
    if (
      isNaN(x) ||
      isNaN(y) ||
      isNaN(width) ||
      isNaN(height) ||
      !isFinite(x) ||
      !isFinite(y) ||
      !isFinite(width) ||
      !isFinite(height)
    ) {
      console.error('StateNode SVG属性包含无效值:', { x, y, width, height });
      // 使用安全的默认值
      x = 0;
      y = 0;
      width = 70;
      height = 30;
    }

    const rx = 15; // 圆角半径

    return h('g', {}, [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width: width,
        height: height,
        rx: rx,
        ry: rx,
        fill: '#ffffff',
        stroke: '#808000',
        strokeWidth: 2,
      }),
    ]);
  }
}

export class StateNodeModel extends RectNodeModel {
  initNodeData(data: any) {
    super.initNodeData(data);
    this.width = 70;
    this.height = 30;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    style.fill = '#ffffff';
    style.stroke = '#808000';
    return style;
  }

  // 重写getTextStyle方法，为状态节点设置特定的文字样式
  getTextStyle() {
    const style = super.getTextStyle();
    return {
      ...style,
      color: '#000000',
      overflowMode: 'default' as any,
      lineHeight: 1.2,
      fontSize: 12,
    };
  }
}
